// Features: M004-F0778
// Tests: T-M004-0385
// WebUI #250: the room-controls client over Core's typed room routes (Core #531, room-controls-relay 3.0.0).
// describe: GET /api/v1/rooms/:id/controls answers { success, data: DescribeResult }; this returns the DescribeResult.
// set: POST /api/v1/rooms/:id/controls with exactly { control, value, idempotency_key } and an Idempotency-Key header.
// Errors reach the caller unchanged (the model classifies them). Core adds org, room and principal; none is sent here.
import api from './api';

const controlsPath = (roomId) => `/v1/rooms/${roomId}/controls`;

export const roomControlsApi = {
  describe: async (roomId) => (await api.get(controlsPath(roomId))).data.data,
  set: async (roomId, { control, value }, idempotencyKey) => (await api.post(
    controlsPath(roomId),
    { control, value, idempotency_key: idempotencyKey },
    { headers: { 'Idempotency-Key': idempotencyKey } },
  )).data.data,
};

export default roomControlsApi;
